/*============================================================================
main.js
============================================================================ */
// User Agent
var _ua = (function(u){
  return {
    Tablet:(u.indexOf("windows") != -1 && u.indexOf("touch") != -1)
      || u.indexOf("ipad") != -1
      || (u.indexOf("android") != -1 && u.indexOf("mobile") == -1)
      || (u.indexOf("firefox") != -1 && u.indexOf("tablet") != -1)
      || u.indexOf("kindle") != -1
      || u.indexOf("silk") != -1
      || u.indexOf("playbook") != -1,
    Mobile:(u.indexOf("windows") != -1 && u.indexOf("phone") != -1)
      || u.indexOf("iphone") != -1
      || u.indexOf("ipod") != -1
      || (u.indexOf("android") != -1 && u.indexOf("mobile") != -1)
      || (u.indexOf("firefox") != -1 && u.indexOf("mobile") != -1)
      || u.indexOf("blackberry") != -1
  }
})(window.navigator.userAgent.toLowerCase());


(function(window,$) {
  var fn = {
    // Page Scroll Animation
    pageScroll: function($trigger) {
      if($trigger.length < 1) {
        return this;
      }
      $trigger.on('click',function(event) {
        var _target = $(this).attr('href');

        //#privacy_2
        if( _target === '#privacy_2' ){
        event.preventDefault();
        $('html,body').animate({
          scrollTop: $(_target).offset().top - 150
        },500);
        return;

        //#tokyo || #osaka
        }else if( _target === '#tokyo' ||  _target === '#osaka' ){
        event.preventDefault();

        //SP
        if( matchMedia('(max-width: 768px)').matches ){
          $('html,body').animate({
          scrollTop: $(_target).offset().top - 65
          },500);
       }else{
          $('html,body').animate({
          scrollTop: $(_target).offset().top - 104
          },500);
       }
      }else{
        $('html,body').animate({
          scrollTop: $(_target).offset().top - 104
        },500);
        return;
      }
      });
    },

    //ankerLink map
    ankerLink1: function($trigger) {
      if($trigger.length < 1) {
        return this;
      }
      var hash = location.hash;
      $trigger.on('click', function(e){
        var _target = location.href;
        if( _target == "https://executive.careerinq.com/static/dist/about/" ){
        e.preventDefault();
          $('html,body').animate({
          scrollTop: $('#map').offset().top - 100
          },500);
        return;
        }else{
          location.href = 'https://executive.careerinq.com/static/dist/about/#map';
        }
      });
      //外部からの場合はこれで動く。
       if( hash === '#map' ){
         //アクセス mapの設定
         $('html,body').animate({
          scrollTop:0
          },0);

          //SP
          if( matchMedia('(max-width: 768px)').matches ){
          $('html,body').animate({
          scrollTop: $(hash).offset().top -65
          },500);
       }else{
          $('html,body').animate({
          scrollTop: $(hash).offset().top - 100
          },500);
       }
        return;
        }
    },

    //ankerLink map
    ankerLink2: function($trigger) {
      if($trigger.length < 1) {
        return this;
      }
      var hash = location.hash;
      $trigger.on('click', function(e){

        var _target = location.href;
        if( _target == "https://executive.careerinq.com/static/dist/" ){
        e.preventDefault();
          $('html,body').animate({
          scrollTop: $('#consaltant').offset().top
          },500);
        return;
        }else{
          hash = '#consaltant';
          $('html,body').animate({
          scrollTop:0
          },0);

          //SP
          if( matchMedia('(max-width: 768px)').matches ){
          $('html,body').animate({
          scrollTop: $(hash).offset().top
          },500);
          }else{
          $('html,body').animate({
          scrollTop: $(hash).offset().top
          },500);
       }

        }
      });

      //ページ外リンクからの遷移
       if( hash === '#consaltant' ){
         //アクセス mapの設定
         $('html,body').animate({
          scrollTop:0
          },0);

          //SP
          if( matchMedia('(max-width: 768px)').matches ){
          $('html,body').animate({
          scrollTop: $(hash).offset().top
          },500);
       }else{
          $('html,body').animate({
          scrollTop: $(hash).offset().top 
          },500);
       }
        return;
        }
    },

    //ankerLink footermap (Tokyo)
    ankerLink3: function($trigger) {
      if($trigger.length < 1) {
        return this;
      }
      var hash = location.hash;
      $trigger.on('click', function(e){
        var _target = location.href;
        if( _target == "https://executive.careerinq.com/static/dist/about/" ){
        e.preventDefault();
          $('html,body').animate({
          scrollTop: $('#tokyo').offset().top - 104
          },500);
        return;
        }else{
          hash = '#tokyo';
          $('html,body').animate({
          scrollTop:0
          },0);

          //SP
          if( matchMedia('(max-width: 768px)').matches ){
          $('html,body').animate({
          scrollTop: $(hash).offset().top - 65
          },500);
          }else{
          $('html,body').animate({
          scrollTop: $(hash).offset().top - 104
          },500);
       }

        }
      });

      //ページ外リンクからの遷移
       if( hash === '#tokyo' ){
         //アクセス mapの設定
         $('html,body').animate({
          scrollTop:0
          },0);

          //SP
          if( matchMedia('(max-width: 768px)').matches ){
          $('html,body').animate({
          scrollTop: $(hash).offset().top -65
          },500);
       }else{
          $('html,body').animate({
          scrollTop: $(hash).offset().top - 104
          },500);
       }
        return;
        }
    },

    //ankerLink footermap (Osaka)
    ankerLink4: function($trigger) {
      if($trigger.length < 1) {
        return this;
      }
      var hash = location.hash;
      $trigger.on('click', function(e){
        var _target = location.href;
        if( _target == "https://executive.careerinq.com/static/dist/about/" ){
        e.preventDefault();
          $('html,body').animate({
          scrollTop: $('#osaka').offset().top - 104
          },500);
        return;
        }else{
          hash = '#osaka';
          $('html,body').animate({
          scrollTop:0
          },0);

          //SP
          if( matchMedia('(max-width: 768px)').matches ){
          $('html,body').animate({
          scrollTop: $(hash).offset().top - 65
          },500);
          }else{
          $('html,body').animate({
          scrollTop: $(hash).offset().top - 104
          },500);
        }
      }
      });

      //ページ外リンクからの遷移
       if( hash === '#osaka' ){
         //アクセス mapの設定
         $('html,body').animate({
          scrollTop:0
          },0);

          //SP
          if( matchMedia('(max-width: 768px)').matches ){
          $('html,body').animate({
          scrollTop: $(hash).offset().top - 65
          },500);
       }else{
          $('html,body').animate({
          scrollTop: $(hash).offset().top - 104
          },500);
       }
        return;
        }
    },

    // Go to Top Button
    btnGoTop: function($trigger) {
      if($trigger.length < 1) {
        return this;
      }

      $(window).on('scroll', function() {
        if ($(this).scrollTop() > 100) {
            $trigger.fadeIn("fast");
        } else {
            $trigger.fadeOut("fast");
        }
        scrollHeight = $(document).height();
        scrollPosition = $(window).height() + $(window).scrollTop(); // スクロール量
        footHeight = $("#footer").innerHeight(); // 止める位置
        //ドキュメントの高さと現在地の差がfooterの高さ以下になったら
        if ( scrollHeight - scrollPosition  <= footHeight ) {
          $trigger.addClass('is-absolute');
        } else { //それ以外の場合は
          $trigger.removeClass('is-absolute');
        }
      });
    },

    // serivice Click リテーナー
    seriviceOpn1: function($trigger) {
      if($trigger.length < 1) {
        return this;
      }

      $("#planBtn01").on('click',function(e){
        e.preventDefault();
        $('#plan01').slideDown().css('display','flex');
        $(this).hide();
      });
    },

    // serivice Click 
    seriviceOpn2: function($trigger) {
      if($trigger.length < 1) {
        return this;
      }

      $("#planBtn02").on('click',function(e){
        e.preventDefault();
        $('#plan02').slideDown().css('display','flex');
        $(this).hide();
      });
    },

    // panel 
    panelOpn: function($trigger) {
      if($trigger.length < 1) {
        return this;
      }

      var panel = $('.panelList');
        $.each(panel,function(index,val){
        $(val).hide();
        });
      panel.eq(0).show();

      var a = $(".panel a");

      $(".panel a").on('click',function(e){
        e.preventDefault();

        $.each(a,function(index,val){
          $(val).removeClass('active');
        });

        $(this).addClass('active');
        $.each(panel,function(index,val){
          $(val).hide();
        });

        var number = $(this).attr('href');
        $(number).show();
      });
    },





    // Drawer Menu
    drawerMenu: function() {
      var $trigger = $('.js-drawerTrigger');
      var $target = $('#js-drawer');
      var $pagescroll = $('.close-drawer-scroll');

      // Add Flag
      var state = false;
      var scrollpos;

      $trigger.on('click', function(event) {
        if(state == false) {
          scrollpos = $(window).scrollTop();
          $('body').addClass('is-open-drawer').css({'top': - scrollpos});
          $target.addClass('is-open');
          state = true;
        } else {
          $('body').removeClass('is-open-drawer').css({'top': 0});
          window.scrollTo( 0 , scrollpos );
          $target.removeClass('is-open');
          state = false;
        }
        return false;
      });

      // Inner Page Scroll Link
      $pagescroll.on('click', function() {
        if(state == true) {
          $('body').removeClass('is-open-drawer').css({'top': 0});
          $target.removeClass('is-open');
          var hash = location.href;

          if(this.hasClass('scroll-consaltant') && hash == 'https://executive.careerinq.com/static/dist/'){
            event.preventDefault();
          $('html,body').animate({
            scrollTop: $('#consaltant').offset().top - 100
          },500);

          }else if(this.hasClass('scroll-map') && hash == 'https://executive.careerinq.com/static/dist/about/'){
            event.preventDefault();
          $('html,body').animate({
            scrollTop: $('#map').offset().top
          },500);
                    console.log(22);

          }else{
            return
          }

          state = false;
          return;
        }
      });
    },

    //form [ type = "file" ]
    fileName: function($trigger){
      $trigger.on( 'change', function(){
      var file = $(this).prop('files')[0];
      if(!($(this).parent().find('span').hasClass('filename'))){
       $(this).parent().append('<span class="filename"></span>');
      }
       $(this).next().addClass('changed');
       $(this).parent().find('span').html(file.name);
      } );
    },

    // Add & Remove Header Class
    headerHidden: function () {
      var $header = $('#header');
      var headerH = $header.outerHeight();
      if ($(window).scrollTop() > headerH) {
        $header.addClass('is-scroll');
      } else {
        $header.removeClass('is-scroll');
      }
    },

    headerTransform: function () {
      var $header = $('#header');
      if ($(window).scrollTop() > 800) {
        $header.addClass('is-transform');
      } else {
        $header.removeClass('is-transform');
      }
    },

  };

  $(function() {
    // For All Device
    fn.drawerMenu();
    fn.pageScroll($('.js-scroll'));
    fn.seriviceOpn1($('#plan01'));
    fn.seriviceOpn2($('#plan02'));
    fn.panelOpn($('.panel'));
    fn.btnGoTop($('#js-pagetop'));
    fn.fileName($("input[type='file']"));
    fn.ankerLink1( $('.scroll-map') );
    fn.ankerLink2( $('.scroll-consaltant') );
    fn.ankerLink3( $('.scroll-tokyo') );
    fn.ankerLink4( $('.scroll-osaka') );
    // For SP and Tablet
    //if(_ua.Mobile || _ua.Tablet){
        fn.headerHidden();

    //}
  });

  $(window).on('scroll', function () {

    fn.headerHidden();
    fn.headerTransform();

  });

})(this,jQuery);
